import iziToast from "izitoast";

var deliverynote = {

	delivernoteUrl: null,

	init: function () {
		$("#button--deliverynote--enrole").on("click", function(event) {
			var url = new URL($(this).attr("href"));
			deliverynote.delivernoteUrl = url.origin + url.pathname;
			var count = parseInt(url.searchParams.get('count'));

			if(count > 1) {
				event.preventDefault();
				deliverynote.modalEnroleQuestion(count, url);
			} else {
				return true;
			}
		});

		$("#button--deliverynote--remove").on("click", function(event) {
			var url = new URL($(this).attr("href"));
			deliverynote.delivernoteUrl = url.origin + url.pathname;
			var count = parseInt(url.searchParams.get('count'));
			event.preventDefault();
			deliverynote.modalRemoveQuestion(count, url);
		});
	},

	modalEnroleQuestion: function (count, url) {
		iziToast.question({
			timeout: false,
			close: false,
			overlay: true,
			displayMode: 'once',
			id: 'delivery__note__add__modal',
			zindex: 999,
			title: 'Počet položek k přidání',
			message: '',
			position: 'center',
			buttons: [
				['<button><b>Uložit</b></button>', function (instance, toast) {

					let input = $("#delivery__note__add__modal__count");

					deliverynote.addDeliverynote(input.val())
						.then(function () {
							instance.hide({ transitionOut: 'fadeOut' }, toast, 'save');
						});
				}, true],
				['<button>Zrušit</button>', function (instance, toast) {

					instance.hide({ transitionOut: 'fadeOut' }, toast, 'storno');

				}],
			],
			inputs: [
				['<input type="button" value="-">', 'click', function (instance, toast, input, e) {
					$("#delivery__note__add__modal__count")[0].stepDown();
				}],
				['<input type="number" id="delivery__note__add__modal__count" min="1" max="'+count+'" value="'+count+'">'],
				['<input type="button" value="+">', 'click', function (instance, toast, input, e) {
					$("#delivery__note__add__modal__count")[0].stepUp();
				}]
			],
			onClosing: function(instance, toast, closedBy){
				console.info('Closing | closedBy: ' + closedBy);
			},
			onClosed: function(instance, toast, closedBy){
				console.info('Closed | closedBy: ' + closedBy);
			}
		});
	},

	modalRemoveQuestion: function (count, url) {
		iziToast.question({
			timeout: false,
			close: false,
			overlay: true,
			displayMode: 'once',
			id: 'delivery__note__remove__modal',
			zindex: 999,
			title: 'Upravit počet položek',
			message: '',
			position: 'center',
			buttons: [
				['<button><b>Uložit</b></button>', function (instance, toast) {

					let input = $("#delivery__note__remove__modal__count");

					deliverynote.removeDeliverynote(input.val())
						.then(function () {
							instance.hide({ transitionOut: 'fadeOut' }, toast, 'save');
						});
				}, true],
				['<button>Odebrat vše</button>', function (instance, toast) {

					deliverynote.removeDeliverynote(0)
						.then(function () {
							instance.hide({ transitionOut: 'fadeOut' }, toast, 'save');
						});
				}],
				['<button>Zrušit</button>', function (instance, toast) {

					instance.hide({ transitionOut: 'fadeOut' }, toast, 'storno');

				}],
			],
			inputs: [
				['<input type="button" value="-">', 'click', function (instance, toast, input, e) {
					$("#delivery__note__remove__modal__count")[0].stepDown();
				}],
				['<input type="number" id="delivery__note__remove__modal__count" min="1" max="'+count+'" value="'+count+'">'],
				['<input type="button" value="+">', 'click', function (instance, toast, input, e) {
					$("#delivery__note__remove__modal__count")[0].stepUp();
				}]
			],
			onClosing: function(instance, toast, closedBy){
				console.info('Closing | closedBy: ' + closedBy);
			},
			onClosed: function(instance, toast, closedBy){
				console.info('Closed | closedBy: ' + closedBy);
			}
		});
	},

	addDeliverynote: function (count) {
		return $.ajax({
			url: deliverynote.delivernoteUrl,
			data: {
				ajax: 1,
				action: 'subcontractDeliverynoteEnrole',
				count: count
			},
			dataType: 'json'
		}).done((response) => {
			location.reload();
		})
		.fail(function() {
			iziToast.error(this.responseText);
		});
	},

	removeDeliverynote: function (count) {
		return $.ajax({
			url: deliverynote.delivernoteUrl,
			data: {
				ajax: 1,
				action: 'subcontractDeliverynoteRemove',
				count: count
			},
			dataType: 'json'
		}).done((response) => {
			location.reload();
		})
		.fail(function() {
			iziToast.error(this.responseText);
		});
	}

}

$(document).ready(function (){
	deliverynote.init();
});